import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { sendOtp, userSelector, clearState } from "../../User/UserSlice";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";
import NavBar from "../../components/nav/Nav";
import OtpInput from "react-otp-input";
import backgroundImage from "../../assets/Madagassca_coat.png";
import { useTranslation } from "react-i18next";

const Otp = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { isFetching, isSuccess, isError, errorMessage } =
    useSelector(userSelector);
  const [otp, setOtp] = useState("");

  useEffect(() => {
    return () => {
      dispatch(clearState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      // toast.error(errorMessage || "Verification failed");
      dispatch(clearState());
    }

    if (isSuccess) {
      // toast.success("OTP verified successfully");
      dispatch(clearState());
      history.push("/"); // Using history.push instead of navigate
    }
  }, [isError, isSuccess, dispatch, history, errorMessage]);

  const handleSubmit = async () => {
    if (!otp || otp.length !== 4) {
      toast.error(t("otp_invalid"));
      return;
    }

    try {
      const resultAction = await dispatch(sendOtp({ otp }));
      if (sendOtp.fulfilled.match(resultAction)) {
        toast.success(t("otp_verified"));
        history.push("/");
      } else if (sendOtp.rejected.match(resultAction)) {
        const error = resultAction.payload;
        toast.error(error?.message || t("verification_failed"));
      }
    } catch (err) {
      toast.error(t("unexpected_error"));
    }
  };

  const handleResendOtp = async () => {
    try {
      // Add your resend OTP API call here
      toast.success(t("otp_resent"));
    } catch (error) {
      toast.error(t("otp_resend_failed"));
    }
  };

  return (
    <div style={{ height: "100vh", overflow: "hidden" }}>
      <NavBar />
      <div
        className="container-xxl position-relative"
        style={{ height: "100%", position: "relative" }}
      >
        <style>
          {`
            .background-image {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: -1;
              overflow: hidden;
            }

            .background-image img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              opacity: 0.09;
              filter: grayscale(100%);
            }

            .card-container {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
            }
          `}
        </style>
        <div className="background-image">
          {/* <img src={backgroundImage} alt="Background" /> */}
        </div>
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="col-sm-12 col-md-5 col-lg-5">
            <div className="card shadow-lg p-3 mb-4 bg-white rounded">
              <div className="card-body text-center">
                <h5 className="card-title">{t("enter_otp")}</h5>

                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={4}
                  renderSeparator={<span>-</span>}
                  renderInput={(props) => <input {...props} />}
                  containerStyle={{ justifyContent: "center" }}
                  inputStyle={{
                    width: "3rem",
                    height: "3rem",
                    margin: "0 0.5rem",
                    fontSize: "2rem",
                    borderRadius: "4px",
                    border: "1px solid rgba(0,0,0,0.3)",
                  }}
                />
                <div className="d-flex justify-content-center mt-4">
                  <button
                    className="btn btn-success px-4"
                    onClick={handleSubmit}
                    disabled={isFetching}
                  >
                    {isFetching ? "Verifying..." : "Submit"}
                  </button>
                </div>
                <div className="mt-3">
                  <span>{t("did_not_receive_otp")}</span>
                  <button
                    className="btn btn-link p-0"
                    onClick={handleResendOtp}
                  >{t("resend_otp")}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Otp;
